import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hrqb2yfx3: FaireProductEntity = {
  token: "p_4hrqb2yfx3",
  type: "product",
  name: "Birthday Warrior Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6d70352f33425627aa965f02bef6108e82507b860eef46a6f43c4839db2b2eaa.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b20a9ed8e53ae8f7189a8d1366b20e2610eddf36334abd4d325cbb542a37ec71.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:58.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
